import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import FormItem from '../../../common/forms/FormItem';
import { isRequired } from '../../../../utils/validators';
import CustomerSelect from '../../../common/forms/select/CustomerSelect';

export const NewDiscountCodeAuthorizerForm = ({ handleSubmit, loading }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Autorizadores" required>
          <Field
            name="customerId"
            component={CustomerSelect}
            validate={[isRequired]}
            isMulti
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );
};

NewDiscountCodeAuthorizerForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

NewDiscountCodeAuthorizerForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.SalesUnit.DiscountCodeAuthorizer.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'NewDiscountCodeAuthorizerForm',
})(NewDiscountCodeAuthorizerForm);

export default connect(mapStateToProps, null)(formComponent);
